export const culturalTranslations = {
  // 文化体验相关翻译
  "culturalExperiences": {
    en: "Cultural Experiences",
    zh: "文化体验"
  },
  "culturalExperiencesDescription": {
    en: "Immerse yourself in the rich cultural tapestry of Penang with these authentic local experiences.",
    zh: "通过这些正宗的本地体验，沉浸在槟城丰富的文化织锦中。"
  },
  "peranakan": {
    en: "Peranakan Heritage Experience",
    zh: "娘惹文化体验"
  },
  "peranakanDesc": {
    en: "Explore the unique Peranakan culture through museum visits, cooking classes, and heritage walks in the historic neighborhoods of Georgetown.",
    zh: "通过参观博物馆、烹饪课程和在乔治城历史街区的文化遗产步行，探索独特的娘惹文化。"
  },
  "traditionalCrafts": {
    en: "Traditional Crafts Workshops",
    zh: "传统工艺工作坊"
  },
  "traditionalCraftsDesc": {
    en: "Try your hand at traditional Malaysian crafts like batik painting, traditional pewter crafting, or traditional wooden clogs making.",
    zh: "亲手尝试马来西亚传统工艺，如蜡染画、传统锡器制作或传统木屐制作。"
  },
  "culturalPerformances": {
    en: "Cultural Performances",
    zh: "文化表演"
  },
  "culturalPerformancesDesc": {
    en: "Witness captivating performances of traditional music, dance, and theatrical performances from Penang's diverse cultural communities.",
    zh: "欣赏来自槟城多元文化社区的传统音乐、舞蹈和戏剧表演。"
  },
  "festivalCalendar": {
    en: "Festival Calendar",
    zh: "节日日历"
  },
  "festivalCalendarDesc": {
    en: "Plan your visit around Penang's vibrant cultural festivals including Thaipusam, Georgetown Festival, Hungry Ghost Festival, and Chinese New Year celebrations.",
    zh: "围绕槟城丰富多彩的文化节日安排您的访问，包括大宝森节、乔治城艺术节、盂兰节和农历新年庆祝活动。"
  },
  "diverseCulture": {
    en: "Diverse multicultural society with Malay, Chinese, Indian, and international influences",
    zh: "多元文化社会，融合马来、中国、印度和国际影响"
  },
  "unescoSite": {
    en: "UNESCO World Heritage Site (Georgetown)",
    zh: "联合国教科文组织世界遗产地（乔治城）"
  },
};
